<template>
  <div class="preview-mask" :style="style" v-if="available">
    <preview-position
      v-if="!!current.previewMask.src"
      :current="current"
      :preview-width="previewWidth"
      :preview-height="previewHeight"
      :scale="scale"
    />
  </div>
</template>

<script>
var SCALE_HEIGHT = window.innerWidth * 0.5 - 32;

import PreviewPosition from "./preview-position/PreviewPosition.vue";
import { uploadPreviewAsset } from "@/api/catalog-api/mockup-preview-asset-api/mockupPreviewAsset.api.js";

export default {
  components: { PreviewPosition },
  props: { current: Object },
  data() {
    return {
      available: false,
      previewWidth: null,
      previewHeight: null,
      scale: null,
    };
  },
  computed: {
    style() {
      const { previewWidth, previewHeight, scale } = this;
      const max = previewWidth > previewHeight ? previewWidth : previewHeight;
      return {
        width: `${max * scale}px`,
        height: `${max * scale}px`,
      };
    },
  },
  watch: {
    current: {
      handler() {
        const { current } = this;
        if (!!current.previewMask.file)
          uploadPreviewAsset({
            file: current.previewMask.file,
            jsClass: current.previewMask.jsClass,
            order: current.previewMask.order,
          })
            .then((r) => current.previewMask.updateValues(r))
            .then(() => this.init());
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.available = false;
      if (!this.current.previewMask.src) return;

      const img = new Image();
      img.onload = () => {
        this.previewWidth = img.width;
        this.previewHeight = img.height;
        this.scale = SCALE_HEIGHT / this.previewHeight;
        this.available = true;
      };
      img.src = this.current.previewMask.src;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.preview-mask {
  position: relative;
  display: flex;
  justify-content: center;
  background-color: cornflowerblue;
  flex: none;
  margin-bottom: 6px;
  border-radius: 5px;
}
</style>
